import { render, staticRenderFns } from "./SectoresComerciales.vue?vue&type=template&id=1df7c270&scoped=true&"
import script from "./SectoresComerciales.vue?vue&type=script&lang=js&"
export * from "./SectoresComerciales.vue?vue&type=script&lang=js&"
import style0 from "./SectoresComerciales.vue?vue&type=style&index=0&id=1df7c270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df7c270",
  null
  
)

export default component.exports